import React from "react";
import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "@styles/integrations.module.scss";
import { Context } from "pages/Integrations";

export class GoogleTagManagerDrawer extends React.Component {
  state = {
    savingOptions: false,
    value: null,
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async componentDidMount() {
    const selectedEnvironment =
      await EnvironmentStorage.getSelectedEnvironment();
    const google = await IntegrationsAPI.getGoogleKeys(selectedEnvironment);
    const googleTagManager = google?.google_tag_manager_key;
    this.setState({ value: googleTagManager });
  }

  async onSave() {
    try {
      const { onSave } = this.props;

      await this.setAsyncState({ savingOptions: true });

      const selectedEnvironment =
        await EnvironmentStorage.getSelectedEnvironment();
      const response = await IntegrationsAPI.setGoogleTagManager(
        selectedEnvironment,
        this.state.value
      );

      await this.setAsyncState({ savingOptions: false });
      if (response.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível salvar a chave: ${response.getErrors()[0]}`,
        });
      }
    } catch (e) {
      await this.setAsyncState({ savingOptions: false });
    }
  }

  render() {
    const { visible, onClose } = this.props;
    const { value, savingOptions } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Google Tag Manager"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={this.onSave.bind(this)}
            loading={savingOptions}
            disabled={savingOptions}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />
        
        <div className={styles.scrollContainer}>
          <Input
            design="two"
            label="Google Tag Manager ID"
            placeholder="GTM-XXXXX"
            value={value}
            onChange={(e) => this.setState({ value: e.target.value })}
          />
        </div>
      </Drawer>
    );
  }
}
